import { Card, Row } from 'antd'
import React from 'react'
import Heading from '../../../component/common/Heading'
import CRUDComponent from '../../../component/common/CRUD-Component'
import CONSTANTS from '../../../util/constant/CONSTANTS'
import { convertUTCToLocal } from '../../../util/functions'

const FoodCalorie = () => {
    return (
        <>
            <Card className="my-5">
                <Heading>Food Calories</Heading>
                <Row>
                    <CRUDComponent

                        GET={{
                            API: CONSTANTS.API.Food_calories.getAll,

                            DataModifier: (res, API, Setrefresh) => {
                                return res?.map(data => {
                                    return {
                                        ...data,
                                        no: `FC${data?.id.toString().padStart(7, "0")}`,
                                        updateTime: convertUTCToLocal(data?.updatedAt, 'DD/MM/YYYY hh:mm A')
                                    }
                                })
                            },
                            column: CONSTANTS.TABLE.FOOD_CALORIES_LIST,
                        }}
                        UPDATE={{
                            API: CONSTANTS.API.Food_calories.update,
                            message: "Updated Food Calories successfully",
                            modaltitle: "Update Food Calories Device",
                            modalFields: CONSTANTS.FORM_FIELD.FOOD_CALORIES_MODAL,
                            // payloadModifier: (res) => {
                            //     let payload = {}
                            //     Object.keys(res)?.forEach(ele => {
                            //         if (res[ele]) {
                            //             payload = {
                            //                 ...payload,
                            //                 [ele]: res[ele]
                            //             }
                            //         }
                            //     })
                            //     return payload
                            // },
                        }}
                        CREATE={{
                            API: CONSTANTS.API.Food_calories.add,
                            message: "Created Food Calories successfully",
                            modaltitle: "Add Food Calories Registry",
                            modalFields: CONSTANTS.FORM_FIELD.FOOD_CALORIES_MODAL,
                            // payloadModifier: (res) => {
                            //     return {
                            //         ...res,
                            //         animalType: 'D',
                            //     }
                            // },
                        }}
                        DELETE={{
                            API: CONSTANTS.API.Food_calories.delete,
                            message: "Deleted Food Calories Successfully",
                        }}
                        isSearch={true}

                    />
                </Row>
            </Card>
        </>
    )
}

export default FoodCalorie 